import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markAllNotificationsRead } from '@/services/notifications/mark-all-read';
import { NOTIFICATIONS_QUERY_KEY } from '@/hooks/queries/use-get-notifications';
import { useOrgStore } from '@/stores/org-store';

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useMutation({
    mutationFn: () => {
      if (!orgId) throw new Error('No org ID');
      return markAllNotificationsRead(orgId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
    },
  });
};
